import Graphs from '../Graphs';
import { scaleLinear, scaleBand, scaleOrdinal } from 'd3-scale';
import { max, range } from 'd3-array';
import { select, mouse, event } from 'd3-selection';
import { transition } from 'd3-transition';
import { axisLeft, axisBottom } from 'd3-axis';
import { line, curveLinear, pie, arc } from 'd3-shape';
import { format } from 'd3-format';

import './LineGraph.css';

export default class LineGraph extends Graphs {
  renderChart = () => {
    this.setState({className: "LineGraph"});
    global.transition = transition;
    const node = this.node;
    const padding = 20;
    const thisComp = this;
    const g = select(node)
      .append('g')

    let drillMenu = select(node)
      .append("g")
      .attr("class", "drillMenu")
      .style("display", "none");

    select(node)
      .on('click', function() {
          drillMenu.transition().style('display', 'none')
          thisComp.setState({ selectedSeries: undefined })
      })

    const data = [].concat(this.props.data).sort((a, b) => max(b.map(item => item.value)) - max(a.map(item => item.value)))

    const x = scaleBand()
			.range([padding, this.props.size[0] - padding])
      .padding(0.5)
      .domain(data[0].map(item => item.key))

    const y = scaleLinear()
      .rangeRound([this.props.size[1] - padding, padding])
      .domain([0, max(data.reduce((acc, curr) => [...acc, ...curr], []).map(item => item.value))]);

    const z = scaleOrdinal(this.props.colorScheme)
      .domain(range(data.length))

    g
      .append("g")
      .attr("transform", `translate(${padding}, ${this.props.size[1] - padding/2})`)
      .attr("class", "axis x-axis")
      .call(axisBottom(x).tickSize(0).tickValues(x.domain().filter((d, i, arr) => (!(i%7) || arr.length < 15))));

    g
      .append("g")
      .attr("transform", `translate(${padding*2}, ${0})`)
      .attr("class", "axis y-axis")
      .call(axisLeft(y).tickSize(0).tickFormat(format(".3s")));

    data.forEach((item, idx) => {
      const lineInst = line()
        .x(d => x(d.key))
        .y(d => y(d.value))
        .curve(curveLinear);

      const linePath = g
        .append('path')
        .datum(item)
        .attr("transform", `translate(${padding}, ${0})`)
        .attr("d", lineInst)
        .style("stroke", z(idx))
        .attr("fill", "none")
        .style("stroke-width", "1px")
        .style("stroke-linecap", "round");

      const lineLength = linePath.node().getTotalLength();

      linePath
        .attr("stroke-dasharray", `${lineLength} ${lineLength}`)
        .attr("stroke-dashoffset", lineLength)
        .transition()
        .duration(1000)
        .attr("stroke-dashoffset", 0);

      g
        .selectAll('.dot')
        .data(item)
        .enter()
        .append('circle')
        .attr("r", 2.5)
        .attr("cx", d => x(d.key))
        .attr("cy", d => y(d.value))
        .attr("transform", `translate(${padding}, ${0})`)
        .attr("fill", "none")
        .style('cursor', thisComp.props.drillOptions ? 'pointer' : null)
        .on('mouseover', function() {
          tooltip.style("display", null);
          select(this)
            .transition()
            .attr("r", 10)
        })
        .on('mouseout', function() {
          tooltip.style("display", "none");
          select(this)
            .transition()
            .attr("r", 2.5)
        })
        .on("mousemove", function(d) {
          var xPosition = mouse(this)[0] - 5;
          var yPosition = mouse(this)[1] - 5;
          tooltip.attr("transform", `translate(${xPosition-40}, ${yPosition})`);
          tooltip
            .select("text")
            .text(`${d.key}: ${format('0.3s')(d.value)}`)
            .attr("transform", `translate(${-20},0)`)
          tooltip
            .select('rect')
            .attr('width', () => tooltip.select('text').node().getComputedTextLength()+20)
            .attr('transform', `translate(${-30-tooltip.select('text').node().getComputedTextLength()/16}, 0)`)
        })
        .on('click', function(d, i) {
           // get the index of the series that the rect is in, then use that to find the serieslabel
          if(thisComp.props && thisComp.props.drillOptions) {
            var seriesLabel = d.label
            event.stopPropagation();
            var xPosition = mouse(this)[0] - 5;
            var yPosition = mouse(this)[1] - 5;
            tooltip.style("display", "none");
            thisComp.setState({ selectedSeries: seriesLabel, selectedDate: d.dt })
            drillMenu
              .transition("move")
              .style('display', null)
              .attr("transform", `translate(${xPosition+22}, ${yPosition+10})`)
          }
        })
        .transition()
        .delay((d,i) => 25*i)
        .attr("fill", z(idx))

      const tooltip = select(node).append("g")
        .attr("class", "tooltip")
        .style("display", "none");

      tooltip.append("rect")
        .attr("width", '20')
        .attr("height", 20)
        .attr("fill", "#333");

      tooltip.append("text")
        .attr("x", 30)
        .attr("dy", "1.2em")
        .style("text-anchor", "middle")
        .attr("font-size", "0.5em")
        .attr("fill", "#fff")

      const arced = arc()
        .outerRadius(65)
        .innerRadius(20);

      const pied = pie()
        .sort(null)
        .padAngle(.01)
        .value(d => d);

      const pieDrill = drillMenu
        .selectAll('.arc')
        .data(pied(thisComp.props.drillOptions ? thisComp.props.drillOptions.map(() => 1) : []))
        .enter()
        .append('g')
        .attr('class', 'arc');

      pieDrill
        .append("path")
        .on('mouseover', function () { return select(this).style('fill', 'teal').style('opacity', 1) })
        .on('mouseout', function () { return select(this).transition("fillColor").style('fill', 'teal').style('opacity', 0.7) })
        .on('click', function(d, i) {
          return thisComp.props.drillData ? thisComp.props.drillData[i].onClick({
          date: thisComp.state.selectedDate,
          series: thisComp.state.selectedSeries,
          widgetType: thisComp.props.drillData[i].widgetType,
          widgetTitle: thisComp.props.drillData[i].widgetTitle,
          param: thisComp.props.drillData[i].param,
          filters: thisComp.props.filters
        }) : null
        })
        .style('cursor', 'pointer')
        .attr("d", arced)
        .style("fill", 'teal')
        .style('opacity', 0)
        .transition("entry")
        .style('opacity', 0.7)

      pieDrill
        .append("text")
        .attr("transform", function(d) {
          d.innerRadius = 20;
          d.outerRadius = 50;
          return "translate(" + arced.centroid(d) + ")";
        })
        .on('click', function(d, i) {
          return thisComp.props.drillData ? thisComp.props.drillData[i].onClick({
          date: thisComp.state.selectedDate,
          series: thisComp.state.selectedSeries,
          widgetType: thisComp.props.drillData[i].widgetType,
          widgetTitle: thisComp.props.drillData[i].widgetTitle,
          param: thisComp.props.drillData[i].param,
          filters: thisComp.props.filters
        }) : null
        })
        .style("font-size", '0.5em')
        .style("fill", 'white')
        .attr("text-anchor", "middle")
        .text(function(d, i) { return thisComp.props.drillOptions[i]; });
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Graphs/LineGraphComponent/LineGraph.js